import api from '../views/services/api';

// Converte a VAPID public key (base64url, como vem do backend) pro formato
// Uint8Array que `PushManager.subscribe` exige.
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function isPushSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

// Pede permissão de notificação (se ainda não foi decidida) e inscreve o
// dispositivo/navegador atual pra receber push. Silencioso se não suportado
// (ex: iPhone sem o PWA instalado na tela de início) ou se o usuário negar.
export async function subscribeToPush(appId) {
    if (!appId || !isPushSupported()) return;

    try {
        if (Notification.permission === 'denied') return;

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const registration = await navigator.serviceWorker.ready;

        let subscription = await registration.pushManager.getSubscription();
        if (!subscription) {
            const { data } = await api.get(`v1/apps/${appId}/push/vapid-public-key/`);
            if (!data?.publicKey) return;

            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(data.publicKey)
            });
        }

        await api.post(`v1/apps/${appId}/push-subscriptions/`, subscription.toJSON());
    } catch (error) {
        console.error('Erro ao inscrever notificação push:', error);
    }
}

// Avisa o backend qual conversa está aberta na tela agora (ou null, quando
// fecha) pra ele não mandar push de algo que o atendente já está vendo.
export async function updateViewingConversation(appId, conversationId) {
    if (!appId || !isPushSupported()) return;

    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        if (!subscription) return;

        await api.patch(`v1/apps/${appId}/push-subscriptions/viewing/`, {
            endpoint: subscription.endpoint,
            conversation_id: conversationId || null
        });
    } catch (error) {
        console.error('Erro ao atualizar conversa em visualização:', error);
    }
}
